import './FinplanBA.Web.css';
{
  const href='frontend.default.css?' + window.ragtime.version;
  document.getElementsByTagName("head")[0].insertAdjacentHTML("beforeend", "<link rel='stylesheet' href='" + href + "' />")
}

import 'FinplanBA.Main';
